import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminDeleteInternalTraining = createApiThunk<void, string>(
  "internalTrainings/deleteInternalTraining",
  async (trainingId: string, { extra: { adminRepository } }) => {
    return adminRepository!.deleteInternalTraining(trainingId);
  },
);

export const adminResetDeleteInternalTraining = createAction("internalTrainings/resetDeleteInternalTraining");
